import { render } from "./new-product-stepper-sheet.vue?vue&type=template&id=4e31dfdc"
import script from "./new-product-stepper-sheet.vue?vue&type=script&lang=js"
export * from "./new-product-stepper-sheet.vue?vue&type=script&lang=js"
script.render = render

export default script